module.exports = __webpack_public_path__ + "img/mastercard.18c02ce3.png";